// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.attachments-section[data-v-73fabbf4] {\n  display: block;\n  width: 100%;\n  font-size: 12px;\n}\n.attachments-section__file-cont[data-v-73fabbf4] {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding-left: 30px;\n}\n.attachments-section__file-cont[data-v-73fabbf4]::before {\n  content: '';\n  top: 0;\n  left: 0;\n  background-size: 22px auto;\n}\n", ""]);
// Exports
module.exports = exports;
